<template>
  <div id="app">
    <mask-dialog :showMask="token === null" url="index"></mask-dialog>
    <img :src="userInfo.head_img||'https://ydnb23333.oss-ap-south-1.aliyuncs.com/233.png'" style="width:84px;height: 84px;"
      class="header" />
    <div class="phone-box">
      <div class="phone">
        {{ userInfo.nick_name }}
      </div>
    </div>
    <div class="list-box">
      <div class="flex flex-align-center flex-justify-between" @click="mybankcard">
        <div class="font-16">My bank card</div>
        <img src="https://imgs.hdjfg.com/gift/img/my_next_ico.png" style="width:10px;height: 10px;" />
      </div>
      <div class="flex flex-align-center flex-justify-between margin-top-30" @click="repayment">
        <div class="font-16">My repayment</div>
        <img src="https://imgs.hdjfg.com/gift/img/my_next_ico.png" style="width:10px;height: 10px;" />
      </div>
      <div class="flex flex-align-center flex-justify-between margin-top-30" @click="logout">
        <div class="font-16">Log out</div>
        <img src="https://imgs.hdjfg.com/gift/img/my_next_ico.png" style="width:10px;height: 10px;" />
      </div>
    </div>

  </div>
</template>

<script>
import MaskDialog from './Common/MaskDialog.vue'
export default {
  components: {
    MaskDialog
  },
  data() {
    return {
      userInfo:{
        head_img:'',
        nick_name:''
      },
      token: null
    }
  },
  created() {
    this.token = window.localStorage.getItem('token')
    if (this.token) this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      const { data: res } = await this.$http.post('/api/user/info')
      if (res.code === 0) {
        this.userInfo = res.data
      } else {
        this.$toast(res.msg)
      }
    },

    logout() {
      window.localStorage.removeItem('token')
      this.$router.push({
        name: 'index'
      })
    },

    mybankcard() {
      this.$router.push({
        name: 'mybankcard'
      })
    },
    repayment() {
      this.$router.push({
        name: 'repayment'
      })
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #FFA775;
  min-height: 100vh;
  padding: 30px 18px 0px 18px;
  box-sizing: border-box;
  text-align: center;

  .header {
    border-radius: 50%;
    border: 5px solid #FFA775;
  }

  .phone-box {
    margin-top: -49px;
    height: 103px;
    border-radius: 14px 14px 0px 0px;
    background: #FFF1EA;

    .phone {
      padding: 61px 0px 20px 0px;
      font-weight: bold;
      font-family: HelveticaNeue-Bold, HelveticaNeue;
      font-size: 18px;
    }
  }

  .list-box {
    padding: 30px 16px 22px 16px;
    background: #FFFFFF;
    border-radius: 0px 0px 14px 14px;
  }
}
</style>
